// extracted by mini-css-extract-plugin
export default {"card":"OV","autoAlign":"PV","cardrow":"QV","cardcentered":"RV","details":"SV","imgwrapper":"TV","img":"UV","category":"VV","name":"WV","copy":"XV","detailsbtn":"YV","remove":"ZV","price":"aW","netPrice":"bW","regularPrice":"cW","label":"eW"};
    if(module.hot) {
      // 1737143663363
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  